var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "moodle-original-a",
    cx: "532.855",
    cy: "-537.557",
    gradientTransform: "matrix(1 0 0 -1 -297.6 -460.9)",
    gradientUnits: "userSpaceOnUse",
    r: "209.76"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#FAAF40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".043",
    stopColor: "#F9A538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".112",
    stopColor: "#F89D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".227",
    stopColor: "#F89A2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".528",
    stopColor: "#F7922D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#F37B28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.259 105.754V66.975c0-8.164-3.397-12.244-10.034-12.244-6.629 0-10.034 4.08-10.034 12.244v38.779H66.294V66.975c0-8.164-3.228-12.244-9.862-12.244-6.633 0-10.036 4.08-10.036 12.244v38.779H26.667V64.768c0-8.504 2.891-14.801 8.844-19.223 5.102-3.91 12.246-5.777 20.92-5.777 9.015 0 15.478 2.207 19.727 6.801 3.57-4.594 10.207-6.801 19.897-6.801 8.844 0 15.819 1.867 20.922 5.777 5.951 4.422 8.843 10.719 8.843 19.223v41.152h-19.563v-.166z",
    fill: "url(#moodle-original-a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.539 49.627l-2.041 10.207c18.708 6.291 36.395.166 45.751-16.158-13.778-9.522-26.535.17-43.71 5.951",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.539 47.08c-.681 3.91-1.192 7.65-1.872 11.563 17.857 6.125 35.375.85 44.73-15.137-11.909-13.776-25.17-2.383-42.858 3.574",
    fill: "url(#moodle-original-b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.799 51.668c-8.164-1.701-17.009 2.555-23.131 6.975-3.912-28.57 13.777-27.893 36.903-20.75-1.529 6.975-4.083 16.33-8.502 21.941-.169-3.744-1.869-6.293-5.27-8.166",
    fill: "url(#moodle-original-c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.178 47.08c29.932-18.031 46.77-21.43 81.634-25-40.478 31.969-41.499 25-81.634 25",
    fill: "url(#moodle-original-d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.812 22.246L51.667 45.545",
    fill: "none",
    stroke: "#4A4A4C",
    strokeWidth: ".5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.545 34.66c.34 3.744-.511-3.572 0 0",
    fill: "#231F20",
    opacity: ".23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.178 47.08l49.489-1.535",
    fill: "none",
    stroke: "#A8ABAD",
    strokeWidth: ".5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.484 35.002C33.98 37.383 6.09 43.506 5.747 47.08c-.849 6.631-.167 17.176-.167 17.176",
    fill: "none",
    stroke: "#F16922",
    strokeWidth: ".5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.131 89.596c-3.063-7.652-6.804-16.158-2.384-26.703C8.64 72.756 8.131 80.24 8.131 89.596",
    fill: "#F16922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.076 33.844c.708-.25 1.384-.17 1.509.184.126.355-.344.846-1.052 1.096-.709.256-1.384.172-1.51-.184-.127-.352.344-.844 1.053-1.096z",
    fill: "#6D6E70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "moodle-original-b",
    gradientTransform: "matrix(1 0 0 -1 -297.6 -460.9)",
    gradientUnits: "userSpaceOnUse",
    x1: "324.268",
    x2: "368.932",
    y1: "-509.952",
    y2: "-509.952"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#929497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".124",
    stopColor: "#757578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".279",
    stopColor: "#575658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".44",
    stopColor: "#403E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".609",
    stopColor: "#302D2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".788",
    stopColor: "#262223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "moodle-original-c",
    gradientTransform: "matrix(1 0 0 -1 -297.6 -460.9)",
    gradientUnits: "userSpaceOnUse",
    x1: "332.834",
    x2: "351.377",
    y1: "-495.051",
    y2: "-521.534"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#231F20",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "moodle-original-d",
    gradientTransform: "matrix(1 0 0 -1 -297.6 -460.9)",
    gradientUnits: "userSpaceOnUse",
    x1: "299.778",
    x2: "381.412",
    y1: "-495.802",
    y2: "-495.802"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#929497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".124",
    stopColor: "#757578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".279",
    stopColor: "#575658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".44",
    stopColor: "#403E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".609",
    stopColor: "#302D2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".788",
    stopColor: "#262223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#231F20"
  })));
};